import styled from '@emotion/styled'
import { hexColors } from '@mobi/settings/hexColors'
import { colors, spacing } from '@mobi/component-library/Theme/Common'
import { QuickbetButtonStyled } from '@core/Areas/Quickbet/Components/Buttons/Components/Common.styles'

export const RecieptContainerStyled = styled.div({
  border: `0.1rem solid ${hexColors.veryLightGrey}`,
  backgroundColor: hexColors.white,
  padding: spacing.sm,
})

export const RecieptButtonsContainerStyled = styled.div({
  display: 'flex',
  width: '100%',
  justifyContent: 'space-between',
  gap: '1rem',
  marginTop: '1rem',

  '> *': { flex: 1, flexBasis: 'calc(50% - 1rem)' },

  svg: { maxWidth: '1.6rem' },

  ':empty': { display: 'none' },
})

export const ReceiptButtonStyled = styled(QuickbetButtonStyled)({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  gap: spacing.smx2,
})

export const ReceiptListStyled = styled.dl({
  margin: 0,
  fontSize: '1.2rem',
  lineHeight: 1.4,
})

export const ReceiptListRowStyled = styled.div({
  marginBottom: '0.5rem',
  display: 'flex',
  flexWrap: 'wrap',

  '&:last-of-type': {
    marginBottom: 0,
  },
})

export const ReceiptListItemStyled = styled.dt({
  flexGrow: 1,
  display: 'flex',
  alignItems: 'center',
  margin: 0,

  '&::after': {
    content: '""',
    flexGrow: 1,
    height: '0.2rem',
    marginLeft: '0.4rem',
    marginRight: '0.4rem',
    borderBottom: '0.2rem dotted rgba(0,0,0,0.1)',
  },
})

export const ReceiptListItemTextStyled = styled.dd({
  margin: 0,
  textAlign: 'right',
})

export const ReceiptCampaignTextStyled = styled.span<{ isBonusBet: boolean }>(({ isBonusBet }) => ({
  color: isBonusBet ? colors.success[600] : hexColors.cobalt,
}))
